import { Typography } from '@design-system/components/typography/typography';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { sprinkles } from '@design-system/sprinkles.css';
import { statusText } from './VideoUploadStateModal.css';
import { faCheck } from '@fortawesome/pro-regular-svg-icons';
import { LinearProgress } from '@mui/material';
import { clsx } from 'clsx';
import { bgColorsVars } from '@design-system/vars.css';
import { UploadStatus } from '../../models/library.domain';
import { faTriangleExclamation } from '@fortawesome/pro-solid-svg-icons';

export const ListItemUploadStatus = ({
  status,
  edited,
  progress,
  uploadSizeWarning,
}: {
  status: UploadStatus;
  edited: boolean;
  progress?: number;
  uploadSizeWarning?: boolean;
}) => {
  switch (status) {
    case 'ready':
      return (
        <div className={sprinkles({ display: 'flex', gap: 'l' })}>
          <Typography className={statusText}>Ready for upload</Typography>
          {edited ? (
            <Typography className={sprinkles({ color: 'SUCCESS-100' })}>
              <FontAwesomeIcon icon={faCheck} /> Edited
            </Typography>
          ) : null}
        </div>
      );
    case 'uploading':
      return (
        <div className="flex flex-col">
          {!progress ? (
            <Typography className={statusText}>Pending...</Typography>
          ) : (
            <div
              className={sprinkles({
                display: 'flex',
                alignItems: 'center',
                gap: 'm',
              })}
            >
              <div className="w-full mr-1 inline">
                <LinearProgress
                  variant="determinate"
                  value={progress}
                  data-testid="ListItemUploadStatusProgress"
                  sx={{
                    '&.MuiLinearProgress-root': {
                      width: '100%',
                      background: bgColorsVars['N-20'],
                    },
                    '&.MuiLinearProgress-root > .MuiLinearProgress-bar1Determinate':
                      {
                        background: bgColorsVars['P-80'],
                      },
                  }}
                />
              </div>
              <div>
                <Typography
                  variant="body"
                  className={sprinkles({ color: 'P-80' })}
                >{`${Math.round(progress)}%`}</Typography>
              </div>
            </div>
          )}
          {uploadSizeWarning ? (
            <div className="flex gap-1">
              <FontAwesomeIcon
                icon={faTriangleExclamation}
                className={sprinkles({ color: 'WARNING-900', fontSize: 's' })}
              />
              <Typography
                variant="body"
                size="small"
                className={sprinkles({ color: 'N-60' })}
              >
                Upload takes longer due to file size
              </Typography>
            </div>
          ) : null}
        </div>
      );
    case 'finished':
      return (
        <Typography
          className={clsx(statusText, sprinkles({ color: 'SUCCESS-100' }))}
        >
          File uploaded successfully
        </Typography>
      );
    case 'error':
      return (
        <Typography
          className={clsx(statusText, sprinkles({ color: 'ERROR-100' }))}
        >
          File failed to upload
        </Typography>
      );
  }
};
